import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';

const items = [
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
    ),
    title: 'Nota de Prensa Corporativa',
    description:
      'Redacción y distribución de un comunicado sobre su participación, hitos y lanzamientos dentro de la Expo.',
    price: 30,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
    title: 'Artículo en TNO Digest',
    description:
      'Crónica especializada "Inside the Booth" para destacar su tecnología, servicios y propuesta de valor frente al mercado.',
    price: 30,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    title: 'Reseña de Posicionamiento',
    description:
      'Inclusión destacada en el balance editorial "Líderes de la Expo Petróleo 2026" para reforzar liderazgo sectorial.',
    price: 20,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    title: 'Dossier de Cobertura',
    description:
      'Entrega de fotografías profesionales de su stand y equipo para archivo institucional, prensa y comunicaciones corporativas.',
    price: 20,
  },
  {
    icon: (
      <svg width={28} height={28} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
    ),
    title: 'Menciones en LinkedIn TNO',
    description:
      'Posteo estratégico dirigido al nicho corporativo, energético y empresarial para amplificar su visibilidad B2B.',
    price: 20,
  },
];

const ContenidoParaMarcas = () => {
  const theme = useTheme();
  const totalPrecio = items.reduce((sum, item) => sum + item.price, 0);

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Paquete Corporate Digest
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Respaldo editorial y de prensa para su huella digital
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ maxWidth: 760, mx: 'auto' }}
        >
          La cobertura trasciende la pantalla para vivir en el ecosistema escrito
          y profesional de TNO Network. Cada pieza fortalece su posicionamiento
          como actor relevante en el sector energético durante una ventana de 3
          meses.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} data-aos="fade-up">
            <Box
              component={Card}
              height="100%"
              variant="outlined"
              sx={{
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  boxShadow: 4,
                  borderColor: theme.palette.primary.main,
                },
              }}
            >
              <CardContent>
                <Box
                  component={Avatar}
                  variant="rounded"
                  sx={{
                    width: 56,
                    height: 56,
                    mb: 2,
                    bgcolor: `${theme.palette.primary.light}33`,
                    color: theme.palette.primary.dark,
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  {item.description}
                </Typography>
                <Typography variant="h6" fontWeight={700} color="primary">
                  ${item.price}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Box
        component={Card}
        sx={{
          mt: 4,
          borderLeft: 4,
          borderColor: theme.palette.primary.main,
          bgcolor: theme.palette.primary.main,
          color: theme.palette.common.white,
        }}
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={2}
          >
            <Typography variant="h6" fontWeight={700} sx={{ color: theme.palette.common.white }}>
              Total paquete editorial B2B
            </Typography>
            <Typography variant="h5" fontWeight={900} sx={{ color: theme.palette.common.white }}>
              ${totalPrecio}
            </Typography>
          </Box>
        </CardContent>
      </Box>
    </Box>
  );
};

export default ContenidoParaMarcas;
